import {scenarioActionTypes as types} from '@/store/actionTypes'
import ScenarioService from "@/services/scenario.service";
import AppService from "@/services/app.service";
import lodash from 'lodash'
import NLP_Service from "@/services/nlp.service";
import $utils from "@/utils/utils";
import CampaignService from "@/services/campaign.service";

const {NodeType, OperatorType, ScenarioMode} = ScenarioService

const state = {
    variableList: [],
    globalSettingList: [],
    dictionaryTtsList: [],
    treeData: null,
    treeUpdate: 0,
    scenario: null,
    editingUserList: [],
    scenario_setting: null,
    editing_user: null,
    exceptionMap: {},
    showAllException: false,
    savingCount: 0,

    //nlp data
    intentList: [],
    entityList: [],
    sampleList: [],
    keywordList: [],
    dictionaryList: [],

    // node mapping for easy checking
    nodeMap: {},
    parentMap: {},
    parentNodeSlugMap: {},
    portalSourceMap: {},
    nodeHasPortal: {},
    nodeSettingVariableList: [],
    scenarioAudioList: [],
    kbSettingList: [],
    audioEngineList: [],

    // guardrail
    useGuardrail: false,
    llmClassifierList: [],
    llmResponseList: [],
    llmConfigs: [],
    allowedLLMConfigs: [],

    // global lua
    globalLua: [],

    // tenant name
    tenantName: ""
}

const mutations = {
    [types.SCENARIO](state, value) {
        state.scenario = value
    },
    [types.SCENARIO_SETTING](state, value) {
        state.scenario_setting = value
        if (value.version === 3) {
            state.tenantName = value.nlp_setting.tenant_name
        } else {
            state.tenantName = ""
        }

    },
    [types.EDITING_USER_LIST](state, value) {
        state.editingUserList = value
    },
    [types.EDITING_USER](state, value) {
        state.editing_user = value
    },
    [types.TREE_DATA](state, value) {
        state.treeData = value
        let nodeMap = {}
        let parentMap = {}
        let parentNodeSlugMap = {}
        let portalSourceMap = {}
        let nodeHasPortal = {}
        let rootPortalNodes = new Set()
        for (let node of state.treeData.nodeList) {
            nodeMap[node.id] = node
            nodeHasPortal[node.id] = []
            // get list root portal nodes
            if (node.type === NodeType.PORTAL) {
                rootPortalNodes.add(node.config.id)
            }
        }
        // add field "is_root_portal" for root portal nodes
        for (let idNode of [...rootPortalNodes]) {
            let rootNode = state.treeData.nodeList.find(i => i.id === idNode)
            rootNode.is_root_portal = true
        }

        for (let node of state.treeData.nodeList) {
            for (let childId of node.children) {
                let childNode = state.treeData.nodeList.find(i => i.id === childId)
                if (childNode.slug) {
                    parentNodeSlugMap[childNode.slug] = node
                }
                parentMap[childId] = node
            }
            if (node.type === NodeType.PORTAL) {
                let source = nodeMap[node.config.id]
                if (source) {
                    portalSourceMap[node.id] = source
                    nodeHasPortal[source.id].push(node)
                } else {
                    console.log('no source found', node.name, node.id, node.config.id);
                    console.log(node);
                }
            } else {
                portalSourceMap[node.id] = null
            }
        }
        state.nodeMap = nodeMap
        state.parentMap = parentMap
        state.parentNodeSlugMap = parentNodeSlugMap
        state.portalSourceMap = portalSourceMap
        state.nodeHasPortal = nodeHasPortal
        state.treeUpdate = new Date().getTime()
    },
    [types.EXCEPTION_MAP](state, value) {
        state.exceptionMap = value
        state.treeUpdate = new Date().getTime()
    },
    [types.EXCEPTION](state, {id, status}) {
        state.exceptionMap[id] = status
        state.treeUpdate = new Date().getTime()
    },
    [types.INTENT_LIST](state, value) {
        state.intentList = value
    },
    [types.ENTITY_LIST](state, value) {
        state.entityList = value
    },
    [types.SAMPLE_LIST](state, value) {
        state.sampleList = value
    },
    [types.KEYWORD_LIST](state, value) {
        state.keywordList = value
    },
    [types.DICTIONARY_LIST](state, value) {
        state.dictionaryList = value
    },
    [types.TOGGLE_EXCEPTION](state) {
        state.showAllException = !state.showAllException
        for (let i in state.exceptionMap) {
            state.exceptionMap[i] = state.showAllException
        }
        state.treeUpdate = new Date().getTime()
    },
    [types.INCREASE_SAVING_COUNT](state) {
        state.savingCount += 1
    },
    [types.DECREASE_SAVING_COUNT](state) {
        state.savingCount -= 1
    },
    [types.VARIABLE](state, value) {
        state.variableList = value
    },
    [types.NODE_SETTING_VARIABLE](state, value) {
        state.nodeSettingVariableList = value
    },
    [types.DICTIONARY_TTS](state, value) {
        state.dictionaryTtsList = value
    },
    [types.GLOBAL_SETTING](state, value) {
        state.globalSettingList = value
    },
    [types.SCENARIO_AUDIO](state, value) {
        state.scenarioAudioList = value
    },
    [types.KB_SETTING](state, value) {
        state.kbSettingList = value
    },
    [types.AUDIO_ENGINE](state, value) {
        state.audioEngineList = value
    },
    [types.USE_GUARDRAIL](state, value) {
        state.useGuardrail = value
    },
    [types.LLM_CONFIGS](state, value) {
        state.llmConfigs = value
    },
    [types.LLM_CLASSIFIER](state, value) {
        state.llmClassifierList = value
    },
    [types.LLM_RESPONSE](state, value) {
        state.llmResponseList = value
    },
    [types.ALLOWED_LLM_CONFIGS](state, value) {
        state.allowedLLMConfigs = value
    },
    [types.GLOBAL_LUA](state, value) {
        state.globalLua = value
    },
    [types.TENANT_NAME](state, value) {
        state.tenantName = value
    }
}

const updateTreeThenReload = (promise, i18n, context) => {
    context.commit(types.INCREASE_SAVING_COUNT)
    return new Promise((resolve, reject) => {
        promise.then(
            result => {
                // AppService.toastSuccess(window.vueapp.$t('actionSuccessful', i18n))
                context.dispatch(types.GET_TREE_DATA)
                resolve(result.data)
            },
            e => {
                AppService.handleRequestError(window.vueapp.$t('actionFailed', i18n))(e)
                reject(e)
            }
        ).finally(() => context.commit(types.DECREASE_SAVING_COUNT))
    })
}

const actions = {
    [types.GET_TREE_DATA](context, payload) {
        let scenarioId = payload || window.vueapp.$route.params.scenarioId
        return ScenarioService.getScenarioData(scenarioId).then(
            result => {
                let data = result.data
                context.dispatch(types.SCENARIO_SETTING, {...data.scenario_setting})
                context.dispatch(types.SCENARIO, {...data.scenario})
                context.commit(types.ALLOWED_LLM_CONFIGS, data.scenario.llm_config)
                context.dispatch(types.UPDATE_EDITING_USERS, scenarioId)
                context.dispatch(types.GET_LLM_CONFIGS, scenarioId)
                context.commit(types.USE_GUARDRAIL, data.use_guardrail)
                let linkList = data.nodes.map(node => {
                    return node.children.map(child => ({
                        from: node.id,
                        to: child
                    }))
                }).flat()
                const nodeMap = {}
                const exceptionMap = {}
                data.nodes.forEach(node => {
                    nodeMap[node.id] = node
                    exceptionMap[node.id] = false
                    node.config = node.config || {}
                })
                data.nodes.forEach(node => {
                    node.config.cardList = node.config.cardList || []
                    if (node.type === NodeType.DECISION) {
                        if (!node.config.conditionList || node.config.conditionList.length === 0) {
                            node.config.conditionList = [
                                [
                                    {
                                        variable: '$intent',
                                        operator: OperatorType.IN,
                                        value: ''
                                    }
                                ]
                            ]
                        }
                    } else if (node.type === NodeType.PROCESS) {
                        node.children = lodash.orderBy(node.children, childId => nodeMap[childId].created_time)
                    }
                })
                let nodeStart = data.nodes.find(node => node.id === data.scenario.start_node)
                context.commit(types.TREE_DATA, {
                    startId: data.scenario.start_node,
                    startSlug: nodeStart ? nodeStart.slug : '',
                    nodeList: data.nodes,
                    linkList: linkList
                })
                if (context.state.exceptionMap) {
                    context.commit(types.EXCEPTION_MAP, {...exceptionMap, ...context.state.exceptionMap})
                } else {
                    context.commit(types.EXCEPTION_MAP, exceptionMap)
                }
            },
            AppService.handleRequestError()
        )
    },
    [types.UPDATE_EDITING_USERS](context, payload) {
        return ScenarioService.UserModeService.search(payload, {is_editing: true}).then(result => {
            let data = result.data ? result.data : []
            // create map color
            const mapColor = new Map()
            context.state.editingUserList.forEach(item => {
                mapColor.set(item.id, item.color)
            })
            // update data result
            data.forEach(i => {
                i.color = mapColor.has(i.id) ? mapColor.get(i.id) : $utils.getRandomColor()
                i.user.acronym = $utils.getAcronymsName(i.user.name)
            })
            context.dispatch(types.EDITING_USER_LIST, data)
        })
    },
    [types.CREATE_EDITING_USER](context, payload) {
        return ScenarioService.UserModeService.create(payload, {is_editing: false}).then(result => {
            let data = result.data
            context.dispatch(types.EDITING_USER, data)
        })
    },
    [types.ADD_NODE](context, payload) {
        return updateTreeThenReload(
            ScenarioService.NodeService.create(payload.scenarioId, payload.model),
            {
                action: window.vueapp.$t('add'),
                item: window.vueapp.$t('node')
            },
            context
        )
    },
    [types.UPDATE_NODE](context, payload) {
        return updateTreeThenReload(
            ScenarioService.NodeService.update(payload.scenarioId, payload.id, payload.model),
            {
                action: window.vueapp.$t('update'),
                item: window.vueapp.$t('node')
            },
            context
        )
    },
    [types.DELETE_NODE](context, payload) {
        return updateTreeThenReload(
            ScenarioService.NodeService.delete(payload.scenarioId, payload.id),
            {
                action: window.vueapp.$t('delete'),
                item: window.vueapp.$t('node')
            },
            context
        )
    },
    [types.ADD_LINK](context, payload) {
        return updateTreeThenReload(
            ScenarioService.NodeService.addLink(payload.scenarioId, payload.fromId, payload.toId),
            {
                action: window.vueapp.$t('update'),
                item: window.vueapp.$t('node')
            },
            context
        )
    },
    [types.DELETE_LINK](context, payload) {
        return updateTreeThenReload(
            ScenarioService.NodeService.deleteLink(payload.scenarioId, payload.fromId, payload.toId),
            {
                action: window.vueapp.$t('update'),
                item: window.vueapp.$t('node')
            },
            context
        )
    },
    [types.EXCEPTION]({commit}, payload) {
        commit(types.EXCEPTION, payload)
    },
    [types.SCENARIO]({commit}, payload) {
        commit(types.SCENARIO, payload)
    },
    [types.SCENARIO_SETTING]({commit}, payload) {
        commit(types.SCENARIO_SETTING, payload)
    },
    [types.EDITING_USER_LIST]({commit}, payload) {
        commit(types.EDITING_USER_LIST, payload)
    },
    [types.EDITING_USER]({commit}, payload) {
        commit(types.EDITING_USER, payload)
    },
    [types.TOGGLE_EXCEPTION](context) {
        context.commit(types.TOGGLE_EXCEPTION)
    },
    [types.GET_NLP](context, payload) {
        NLP_Service.getData(payload).then(
            result => {
                let data = result.data
                // sample
                if (Array.isArray(data.sample)) {
                    context.commit(types.SAMPLE_LIST, data.sample)
                } else {
                    AppService.toastError('can not load sample list')
                    context.commit(types.SAMPLE_LIST, [])
                }
                // intent
                if (Array.isArray(data.intent)) {
                    context.commit(types.INTENT_LIST, data.intent)
                } else {
                    AppService.toastError('can not load intent list')
                    context.commit(types.INTENT_LIST, [])
                }
                // entity
                if (Array.isArray(data.entity)) {
                    context.commit(types.ENTITY_LIST, data.entity)
                } else {
                    AppService.toastError('can not load entity list')
                    context.commit(types.ENTITY_LIST, [])
                }
                // keyword
                if (Array.isArray(data.keyword)) {
                    data.keyword.forEach(item => {
                        item.synonym = JSON.parse(item.synonym)
                        item.entity_label = context.state.entityList.find(entity => entity.code === item.entity_code).label
                    })
                    context.commit(types.KEYWORD_LIST, data.keyword)
                } else {
                    AppService.toastError('can not load keyword list')
                    context.commit(types.KEYWORD_LIST, [])
                }
                // dictionary
                if (Array.isArray(data.dictionary)) {
                    data.dictionary.forEach(item => {
                        item.meaning = JSON.parse(item.meaning)
                    })
                    context.commit(types.DICTIONARY_LIST, data.dictionary)
                } else {
                    AppService.toastError('can not load dictionary list')
                    context.commit(types.DICTIONARY_LIST, [])
                }
            }
        )
    },
    [types.CLEAR_NLP](context) {
        context.commit(types.SAMPLE_LIST, [])
        context.commit(types.INTENT_LIST, [])
        context.commit(types.ENTITY_LIST, [])
        context.commit(types.KEYWORD_LIST, [])
        context.commit(types.DICTIONARY_LIST, [])
    },
    [types.GET_INTENT_LIST](context, payload) {
        return NLP_Service.IntentService.search(payload).then(
            result => {
                context.commit(types.INTENT_LIST, result.data)
            },
            AppService.handleRequestError()
        )
    },
    [types.GET_ENTITY_LIST](context, payload) {
        NLP_Service.EntityService.search(payload).then(
            result => {
                context.commit(types.ENTITY_LIST, result.data)
            },
            AppService.handleRequestError()
        )
    },
    [types.GET_SAMPLE_LIST](context, payload) {
        NLP_Service.SampleService.search(payload).then(
            result => {
                context.commit(types.SAMPLE_LIST, result.data)
            },
            AppService.handleRequestError()
        )
    },
    [types.GET_KEYWORD_LIST](context, payload) {
        NLP_Service.KeywordService.search(payload).then(
            result => {
                let data = result.data
                data.forEach(item => {
                    item.synonym = JSON.parse(item.synonym)
                    item.entity_label = context.state.entityList.find(entity => entity.code === item.entity_code).label
                })
                context.commit(types.KEYWORD_LIST, data)
            },
            AppService.handleRequestError()
        )
    },
    [types.GET_DICTIONARY_LIST](context, payload) {
        NLP_Service.DictionaryService.search(payload).then(
            result => {
                let data = result.data
                data.forEach(item => {
                    item.meaning = JSON.parse(item.meaning)
                })
                context.commit(types.DICTIONARY_LIST, data)
            },
            AppService.handleRequestError()
        )
    },
    [types.GET_VARIABLE](context, payload) {
        return ScenarioService.VariableService.search(payload).then(
            result => {
                context.commit(types.VARIABLE, result.data)
            },
            AppService.handleRequestError(window.vueapp.$t('actionFailed', {
                action: window.vueapp.$t('load'),
                item: window.vueapp.$t('variable')
            }))
        )
    },
    [types.GET_NODE_SETTING_VARIABLE_LIST](context) {
        return ScenarioService.getNodeSettingVariables().then(
            result => {
                context.commit(types.NODE_SETTING_VARIABLE, result.data)
            },
            AppService.handleRequestError(window.vueapp.$t('actionFailed', {
                action: window.vueapp.$t('load'),
                item: window.vueapp.$t('variable')
            }))
        )
    },
    [types.GET_DICTIONARY_TTS](context, payload) {
        return ScenarioService.DictionaryService.search(payload).then(
            result => {
                context.commit(types.DICTIONARY_TTS, result.data)
            },
            AppService.handleRequestError(window.vueapp.$t('actionFailed', {
                action: window.vueapp.$t('load'),
                item: window.vueapp.$t('dictionary')
            }))
        )
    },
    [types.GET_GLOBAL_SETTING](context, payload) {
        return ScenarioService.GlobalSettingService.search(payload).then(
            result => {
                context.commit(types.GLOBAL_SETTING, result.data)
            },
            AppService.handleRequestError(window.vueapp.$t('actionFailed', {
                action: window.vueapp.$t('load'),
                item: window.vueapp.$t('globalSetting')
            }))
        )
    },
    [types.GET_SCENARIO_AUDIO](context, payload) {
        return ScenarioService.ScenarioAudioService.search(payload).then(
            result => {
                context.commit(types.SCENARIO_AUDIO, result.data)
            },
            AppService.handleRequestError(window.vueapp.$t('actionFailed', {
                action: window.vueapp.$t('load'),
                item: window.vueapp.$t('audio')
            }))
        )
    },
    [types.GET_KB_SETTING](context, payload) {
        return ScenarioService.KbSettingService.search(payload).then(
            result => {
                context.commit(types.KB_SETTING, result.data)
            },
            AppService.handleRequestError(window.vueapp.$t('actionFailed', {
                action: window.vueapp.$t('load'),
                item: 'kb'
            }))
        )
    },
    [types.GET_AUDIO_ENGINE](context) {
        return ScenarioService.getAudioEngines().then(
            result => {
                context.commit(types.AUDIO_ENGINE, result.data)
            },
            AppService.handleRequestError(window.vueapp.$t('actionFailed', {
                action: window.vueapp.$t('load'),
                item: 'audio_engine'
            }))
        )
    },
    [types.GET_LLM_CONFIGS](context, payload) {
        return ScenarioService.LLMConfigService.search(payload).then(
            result => {
                context.commit(types.LLM_CONFIGS, result.data)
            },
            AppService.handleRequestError(window.vueapp.$t('actionFailed', {
                action: window.vueapp.$t('load'),
                item: 'llm_configs'
            }))
        )
    },
    [types.GET_GLOBAL_LUA](context, payload) {
      return ScenarioService.GlobalLUAService.search(payload).then(
          result => {
              const parsedData = result.data.map(obj => ({
                  ...obj,
                  lua_code: {
                      script: obj.lua_code
                  }
              }));
              context.commit(types.GLOBAL_LUA, parsedData)
          },
          AppService.handleRequestError(window.vueapp.$t('actionFailed', {
              action: window.vueapp.$t('load'),
              item: 'lua_global'
          }))
      )
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
